import { BearingFrequencyCalculator } from "~/pages/BearingFrequencyCalculatorPage/components/BearingFrequencyCalculator";

function BearingFrequencyCalculatorPage() {
  return <BearingFrequencyCalculator />;
}

export function createBearingFrequencyCalculatorPage() {
  return <BearingFrequencyCalculatorPage />;
}
